<nav class="sidebar" [class.collapsed]="collapsed()" aria-label="Navegação principal">

  <div class="sidebar-menu">
    @for (group of groups(); track group.id) {
      <div class="sidebar-group">
        @if (group.label && !collapsed()) {
          <span class="sidebar-group-label">{{ group.label }}</span>
        }
        <ul class="sidebar-group-list" role="list">
          @for (item of group.items; track item.id) {
            <li role="listitem">
              <app-sidebar-menu-item [item]="item" [collapsed]="collapsed()" (itemClick)="onItemClick()" />
            </li>
          }
        </ul>
      </div>
    }
  </div>

  <app-sync-status [collapsed]="collapsed()" />

</nav>
